import React from 'react';
import { Helmet } from 'react-helmet';

import LegalDocument from '../../components/LegalDocument';

function PolicyEn() {
  return (
    <LegalDocument title="Privacy Policy">
      <Helmet>
        <meta name="description" content="EFFECTIVE DATE: June 1, 2018" />
        <meta itemprop="description" content="EFFECTIVE DATE: June 1, 2018" />
        <meta
          property="og:description"
          content="EFFECTIVE DATE: June 1, 2018"
        />
      </Helmet>
      <p>EFFECTIVE DATE: June 1, 2018</p>
      <h4>General Information</h4>
      <p>
        PLEASE READ THIS PRIVACY STATEMENT AND NOTICE OF PRIVACY PRACTICES
        CAREFULLY.
      </p>
      <p>
        This Privacy Statement and Notice of Privacy Practices (“Privacy
        Policy”) sets forth the privacy practices of Spur and its affiliates,
        subsidiaries, agents, representatives, successors and assigns
        (collectively “Spur”) located in the United States. For the purpose of
        the following terms, references to “We”, “Us” and “Our” include Spur and
        its affiliates, subsidiaries, agents, representatives, successors and
        assigns. We create a marketplace for efficiently connecting businesses
        and workers that match one another’s availability and need. These
        offerings are defined under this Privacy Policy collectively and
        individually as Our (“Services”).
      </p>
      <p>
        This Privacy Policy is applicable to all data collection by Spur and
        shall apply to the user’s (“You” or “Your”) use of this Web site, Your
        use of any affiliated third party Web sites that may contain a link to
        this Privacy Policy, to any pages, facilities, services, or capabilities
        accessible on or by any top-level Spur domain owned by Us or any
        subsite, subdomain, subdirectory, virtual site, or virtual directory
        thereof (each, a “Site” and collectively the “Sites”), and the Services.
      </p>
      <p>
        This Privacy Policy shall apply strictly to customer information
        collected in the United States. This Privacy Policy describes how Spur
        treats Your use of the Sites, including the collection, storage,
        transfer, sharing, disclosure and handling of Your personal information
        and Your use of Our Services.
      </p>
      <p>
        By using Our Services, You acknowledge that You have read this Privacy
        Policy and consent to Spur’s privacy practices as described in the
        Privacy Policy, including Our use and disclosure of Your personal
        information for the purposes described below. You further affirm Your
        consent by submitting content or materials to or through Our Services.
      </p>
      <p>
        We take the privacy of Your personal information seriously. If You have
        any questions or concerns about this Privacy Policy or Your personal
        information please contact Us directly at the email or mailing address
        listed in Section 2 (Contact and Electronic Communication).
      </p>
      <h4>Changes and Updates to this Privacy Policy</h4>
      <p>
        Spur reserves the right to revise or update this Privacy Policy at any
        time, and You agree to be bound by those revisions or updates. Spur will
        notify You of any changes to the Privacy Policy by posting the revised
        or updated Privacy Policy and its “Effective” date on the Sites. Your
        use of the Sites thereafter constitutes Your agreement to and acceptance
        of the Privacy Policy and its revisions or updates. You should
        periodically read the Privacy Policy to learn of any revisions or
        updates. This Privacy Policy is incorporated as part of the General
        “Terms of Service” that apply with respect to Your use of the Sites and
        Our Services, which We define below in this Privacy Policy. If You do
        not agree to the terms and conditions of this Privacy Policy, including
        having Your personal information used in any of the ways described in
        this Privacy Policy, please do not provide Us with Your information or
        use the Sites.
      </p>
      <h4>Contact and Electronic Communication</h4>
      <p>
        By using Our Services or providing Your personal information to Us, You
        agree that We can communicate with You electronically regarding any
        legal, regulatory, technical, security, privacy and any administrative
        or consumer notification obligations that may be related to Your use of
        the Services. If You have any questions about this Privacy Policy or
        about Our Services related to the Privacy Policy, You can contact Spur
        by e-mail at <a href="mailto:Legal@SpurJobs.com">Legal@SpurJobs.com</a>.
      </p>
      <p>You may also contact Us at:</p>
      <p>
        Spur, Inc.
        <br />
        Attn: Legal
        <br />
        P.O. Box 107
        <br />
        Huntsville, Alabama 35804
      </p>
      <h4>Types of Information Collected and How it is Collected</h4>
      <p>
        The types of information We collect from You when You access Our Site or
        use Our Services are listed below. Spur may share both Your Information
        with its affiliates, subsidiaries, partners and other third parties,
        such as third parties who help operate the Sites and related databases
        and Our mobile applications. Use of such third parties is subject to the
        terms of use and privacy policies of those third parties. Spur is not
        responsible for the privacy practices of any other Web sites or third
        parties. You should review the terms of use and privacy policies that
        are posted on by those third parties, before using any services they
        provide. Spur accepts no liability for any information, products,
        advertisements, content, services or software accessible through these
        third party websites or for any action You may take as a result of
        linking to any such website. We collect information directly from You,
        through use of Our Sites, mobile applications, or Services or from third
        parties that work with Spur to deliver Our Services.
      </p>
      <h4>Personal Information We Request From You and Background Checks</h4>
      <p>
        Certain areas of the Sites (e.g. creating a user account whether as a
        Worker or Workplace (as such terms are defined in the Terms of Service))
        will require You to provide personal information to Spur. That personal
        information may include Your name, phone number, e-mail address, mailing
        address, zip code, username, password, credit card information, social
        security number, birth date, criminal history, bank account information,
        citizenship status, previous work experience, education background, and
        federal employment identification number. As part of the hiring or
        account registration process, Spur or its affiliates may require You to
        provide a copy of Your driver’s license, passport, military ID, or other
        personal identification card.
      </p>
      <p>
        We or Our designated agents or representatives may request background
        information about You, including available personal information, from a
        consumer reporting agency in connection with Your request to use the
        Site for work purposes. The Fair Credit Reporting Act (the “FCRA”)
        defines such a report, including investigative consumer reports as
        defined under the FCRA, as a “Consumer Report”, and all inquiries are
        limited to information that affects Your performance of potential Jobs
        (as such term is defined in the Terms of Service) through Our Site. All
        requests are conducted in accordance with applicable laws, including the
        FCRA. We use an outside agency for this screening: Yardstik, Inc., 100
        Washington Ave S, Suite 600, Minneapolis, MN 55401, Phone:
        1-888-278-5042. As a result, Yardstik may obtain a Consumer Report on
        You as a user of the Site.
      </p>
      <p>
        <strong>**Authorization and Release:**</strong> Pursuant to the United
        Stated Fair Credit Reporting Act, You hereby authorize Spur and its
        designated agents and representatives to conduct a comprehensive review
        of Your background through a Consumer Report and/or
        <em>
          {' '}
          an investigative consumer report to be generated for prescreening for
          Jobs through Our Site. By accepting this Privacy Policy, You
          acknowledge and agree that You have carefully read and understand this
          disclosure for the procurement of Consumer Reports. You also
          understand that information contained in Your account or otherwise
          disclosed by You before or during Your use of Our Site, if any, may be
          used for the purpose of obtaining Consumer Reports and/
        </em>
        or investigative consumer reports. By accepting this Privacy Policy, You
        authorize law enforcement agencies, learning institutions (including
        public and private schools and universities), information service
        bureaus, credit bureaus, record/data repositories, courts (federal,
        state, local, or international), motor vehicle records agencies, Your
        past or present employers, the military, and other individuals and
        sources to furnish any and all information about You that is requested
        by the consumer reporting agency. You certify the information that You
        provide in order for Spur or its designated agents or representatives to
        obtain a Consumer Report is true and correct and will be valid for any
        reports that may be requested by or on behalf of Spur.
      </p>
      <p>
        In addition, some Workplaces may have additional background check
        requirements that they may require of You before accepting You as a
        Worker. Such Workplaces may share the information they collect about You
        through their own background checks with Us and other third parties,
        including, without limitation, government and regulatory agencies,
        according to the terms of the specific Workplace’s background check. We
        do not control the Workplace’s criteria for collecting or sharing of the
        information the Workplace collects about You through its separate
        background checks; please carefully review the terms and conditions of
        any Workplace’s separate background check required of You.
      </p>
      <p>
        While it is Your choice whether to provide the requested information or
        not, We cannot provide certain Services You request if You do not
        provide the requested information. By submitting this personal
        information to Spur, You agree that Spur may use the information in
        accordance with this Privacy Policy, for example to provide You with the
        Services, match Workers with contact opportunities, adapt and improve
        Spur services to better suit Your needs and to meet legal, regulatory,
        or contractual requirements relating to the services provided to You. If
        You do submit such personal information to Spur, Spur may share that
        information with third parties as set forth in this Privacy Policy, in
        addition to using that information for the purposes for which it was
        submitted by You.
      </p>
      <p>
        Spur may also use this personal information in other ways, such as to
        provide You with information about Services and offers that may be of
        interest to You, to seek follow-up from You about Your experiences with
        Spur or as otherwise disclosed to You at the point of collection. Where
        required, Spur will seek Your express consent to send such messages,
        including when sent by e-mail or other type of commercial electronic
        message. This consent is sought by Spur, P.O. Box 107, Huntsville,
        Alabama 35804. You may withdraw Your consent by using the “unsubscribe”
        link located at the bottom of such messages You receive from Spur, or by
        contacting Spur at the email or postal address listed in Your applicable
        user agreement.
      </p>
      <p>
        Spur may share Your personal information with its affiliates,
        subsidiaries and partners and with other third parties. Additionally, to
        the extent required by applicable federal or state law, Spur may be
        required to disclose Your personal information in response to lawful
        requests by public authorities, including to meet regulatory, national
        security, or law enforcement requirements. By submitting personal
        information to Spur, You give Spur permission to receive it, review it,
        edit it, store it and use it for the purposes described in this Privacy
        Policy.
      </p>
      <h4>Other Types of Information We Collect</h4>
      <p>
        Spur also gathers certain information about Your work preferences, how
        You use Services, Your availability, the use of Spur’s Sites, including
        the number of unique visitors, the frequency of visits, how users
        interact with the Sites, user experience preferences, IP address, and
        other information that may help Spur improve the customer experience,
        mitigate fraudulent activity, and comply with legal requirements. Such
        information may include, but is not limited to, the following:
      </p>
      <h4>Log Information</h4>
      <p>
        When You visit Spur’s Web sites We automatically collect and store
        certain information in Our server logs. This type of information
        includes details of how You interacted with Our Sites, Services, or
        applications. It may include information such as: IP address, Unique
        Device Identifier, or CallerID/ANI (Automatic Number Identification)
        information, content of Web pages, transaction with APIs (Application
        Program Interface), transactions with IVR (Interactive Voice Response)
        systems, activity and content of visitor interaction with call center
        representatives; application usage activity, hardware information,
        hardware and system settings, browser type, browser language, the date
        and time of Your request, referral URL, etc.
      </p>
      <h4>Automatic Collection</h4>
      <p>
        Spur and its partners use cookies or similar technologies to analyze
        trends, administer Spur’s Sites, track users’ movements around the Site,
        and to gather demographic information about Our user base as a whole.
      </p>
      <h4>Cookies</h4>
      <p>
        A cookie is a small, data file that is managed by Your Web browser or
        other application and stored on Your local system. Spur uses session and
        persistent cookies to, among other things, identify Your computer during
        a particular interaction and analyze Your behavior during a particular
        visit. Most Web browsers provide You with the ability to accept or
        decline cookies, as well as to be warned each time a cookie is being
        sent. If You choose to decline cookies, You may not be able to fully use
        Spur’s Sites, Services, or applications.
      </p>
      <h4>Pixel Tags</h4>
      <p>
        Pixel tags, also known as Web beacons, help Spur better manage user
        experience and content tracking. Pixel tags are tiny graphics with a
        unique identifier, which provide a similar function to cookies and are
        used to track user interaction with content provided by Spur or an
        affiliate organization. In contrast to cookies, which are stored on a
        user’s computer hard drive, pixel tags are embedded invisibly within
        content. The small size and transparency of pixel tags are not intended
        to deceive content recipients, but minimize distraction.
      </p>
      <h4>Third Party Data Sources</h4>
      <p>
        Spur may leverage external data sources in order to provide context and
        background on the users of its Sites, Services, or mobile applications
        in order to improve customer experience, mitigate fraud or malicious
        activity, or comply with internal company and external regulatory
        requirements.
      </p>
      <h4>Do Not Track and Third Party Advertising Cookies</h4>
      <p>
        Do-Not-Track is a public-private initiative,{' '}
        <a href="https://www.w3.org/2011/tracking-protection/">
          {' '}
          http://www.w3.org/2011/tracking-protection/
        </a>
        , that has developed a technical “flag” or signal that an end-user may
        be able to activate within their browser software to notify Web sites
        that they do not wish to be “tracked” by third parties as defined by the
        initiative. The initiative, however, has not reached a consensus as to
        exactly what technical or other actions those parties receiving the
        signal should take. As a result, Do-Not-Track has not yet been
        standardized and most Web sites, including Spur Sites, do not alter
        their behavior or change their services when they receive a
        “do-not-track” flag or signal. You can, however, make decisions about
        Your privacy and the advertisements You receive.
      </p>
      <p>
        Some of the ads You receive on Sites are customized based on predictions
        about Your interests generated from Your visits to different Sites. This
        type of ad customization is sometimes called “online behavioral” or
        “interest-based” advertising.
      </p>
      <p>
        We partner with a third party to manage Our advertising on other sites.
        Our third party partner may use cookies or similar technologies in order
        to provide You advertising based upon Your browsing activities and
        interests. If You wish to opt out of interest-based advertising click
        here. Please note You will continue to receive generic ads.
      </p>
      <p>
        As an alternative to the opt-out, You can also elect to block all
        cookies from first parties (such as Spur) and from third parties (such
        as entities involved in advertising) by using the cookie blocking
        options built into Your browser software. Please note, however, that if
        You do decide to block cookies, some parts of Spur’s Sites may not
        function correctly.
      </p>
      <h4>Retention and Deletion of Personal Information</h4>
      <p>
        Spur will retain Your personal information for as long as necessary to
        fulfill the purpose(s) for which it was collected and to comply with
        applicable laws, and Your consent to such purposes(s) remains valid with
        respect to claims data and to file claims related to insurance coverage
        after termination of Spur’s relationship with You. When personal
        information is no longer needed or legally required, it will be
        permanently deleted or de-identified so that it can no longer be
        associated with a specific individual.
      </p>
      <h4>Use of Personal Information</h4>
      <p>
        In addition to any of the previously mentioned uses of personal
        information, Spur may use Your information collected on the Sites for
        such purposes as: (a) helping to establish and verify Your identity; (b)
        activating and maintaining Your account; (c) contacting You to offer
        Service updates and notices, promotional notices and other information
        about Services or other services available from Spur or its affiliates;
        (d) providing You with Services You have requested or authorized; (e)
        responding to Your questions, inquiries, comments and instructions; (f)
        improving the Sites by solving technical problems, calculating overall
        usage statistics, internal marketing and promotional purposes, Service
        development and content improvement; (g) taking good faith steps to
        enforce terms and conditions; and (h) maintaining the security and
        integrity of the Sites and Spur’s systems.
      </p>
      <h4>Sharing and Disclosure of Personal Information</h4>
      <p>
        Primarily, We may share or disclose Your personal information in the
        following instances:
      </p>
      <ul>
        <li>
          To fulfill a service to You. For example, if You e-mail Us a question,
          We may use Your e-mail address to process Your request and respond to
          Your question.
        </li>
        <li>
          To provide the Services to You. We will disclose Your contact
          information as necessary to Workers that You request for Jobs so they
          may contact You to provide the Services. As set forth in a separate
          written agreement between You and Us.
        </li>
        <li>
          To offer You products from Our affiliates, strategic partners, agents,
          or from third-party marketers and other unaffiliated parties that We
          believe may be of interest to You, or to assist such parties for
          research, administrative, and/or business purposes. These parties are
          obligated by contract to only use the information they are provided
          for the purposes specified by Spur.
        </li>
        <li>
          To unaffiliated third-party service providers, agents, or independent
          contractors who help Us maintain Our services and provide Us with
          other administrative services (including, but not limited to,
          providing Spur with insurance, order processing and fulfillment,
          providing customer service, maintaining and analyzing data, and
          sending customer communications on Our behalf). Spur requires these
          service-related companies to contractually comply with the principles
          set out in the Privacy Policy, and require them to use such
          information only for the purposes for which it was provided to them.
        </li>
        <li>
          To complete Your purchase of the Services. If You choose to make a
          purchase of one of Our Services, We may ask You for Your credit card
          number, billing address, and other information in connection with
          completing such purchase, and We may use such information to fulfill
          Your purchase. We may also provide such information, or other personal
          information provided by You, to unaffiliated third-parties to complete
          Your purchase (for example, to process Your credit card). These
          third-parties are contractually bound to use the information provided
          only for the purposes specified by Spur.
        </li>
        <li>
          To pay You. If You become a user of Spur, We may ask You for Your bank
          account and other necessary information to transmit Your earnings to
          You. We may also provide such information, or other personal
          information provided by You, to unaffiliated third-parties to complete
          Our payment to You. These third-parties are contractually bound to use
          the information provided only for the purposes specified by Spur.
        </li>
        <li>
          To comply with law, or in the good faith belief that such action is
          necessary to conform to the requirements of law, or comply with legal
          process served on Us, and to protect and defend Our rights or
          property, including Our rights and property and Our services, or act
          in urgent circumstances to protect the personal safety of You and Our
          other visitors.
        </li>
        <li>
          We may use anonymized or general information derived from the data We
          collect from You and aggregate it with information from Our other
          customers and visitors (“Non-Identifiable Aggregated Data”) for Our
          business purposes, including without limitation for analyzing customer
          needs and improving Our Services, and We will own all right, title and
          interest in any such Non-Identifiable Aggregated Data. Your data may
          be co-owned by third parties unaffiliated with Us.
        </li>
        <li>
          To protect against fraud and potential fraud. We may verify the
          information You provide to obtain Our Services through third parties
          who are contractually prohibited from using any information We provide
          to them for any purpose not specified by Spur. In the course of such
          verification, We may receive additional personal information about You
          from such services. In particular, if You use a credit card or debit
          card to purchase services with Us, We may use card authorization and
          fraud screening services to verify that Your card information and
          address match the information You supplied to Us, and that the card
          has not been reported as lost or stolen.
        </li>
        <li>
          To market Our Sites, Services, and mobile applications. We may use the
          information You provide in Your profile, such as Your name, picture,
          the date You created Your account, Your employment and/or education
          history, previous Jobs You have completed or submitted, ratings of
          other users, and self-description in Our marketing materials to third
          parties.
        </li>
      </ul>
      <h4>Legal Disclosure</h4>
      <p>
        We may disclose information about You and Your use of the services if We
        believe that such disclosure is reasonably necessary to: (i) comply with
        the law and/or
        <em>
          {' '}
          legal process where a formal request has been made (e.g. request from
          an administrative oversight agency, civil suit, subpoena, court order
          or judicial or administrative proceeding); (ii) protect or defend Our
          rights and/or
        </em>{' '}
        property or the rights and property of others; (iii) enforce Our General
        Terms of Use and/or this Privacy Policy; (iv) respond to claims that the
        content(s) of a communication violates the rights of another; and (v) to
        meet Our legal and regulatory obligations, including, without
        limitation, as an employer and for tax purposes.
      </p>
      <p>
        Also, circumstances may arise where, for business reasons, We may decide
        to reorganize, or divest all or part of Our business through sale,
        assignment, merger, acquisition, bankruptcy proceedings, or We may
        acquire a new business. In these circumstances, personal information may
        be shared with the actual or prospective purchasers or assignees, or
        with the newly acquired business.
      </p>
      <h4>People Under the Age of 18</h4>
      <p>
        The Services provided by Spur are not directed or available to persons
        under eighteen (18) years of age or the legal age of majority in Your
        state. If You become aware that Your child, who is under eighteen (18)
        years of age or the age of majority as may otherwise be dictated in Your
        state, is accessing the Services and providing personal information
        without Your consent, please contact Us by using the information
        provided in the Contact and Electronic Communication section of this
        Privacy Policy. Spur will take steps to remove the child’s personal
        information from Spur’s data collection systems and terminate Your
        child’s account should Spur determine that anyone under the age of
        majority as set in Your state or jurisdiction has accessed the Services.
      </p>
      <h4>Security of Information</h4>
      <p>
        Information submitted via the Internet, including through a Web page,
        mobile application, or e-mail is subject to interception or incorrect
        routing, and the Internet is not a fully secure communications channel.
        Please consider this prior to submitting any information to Spur via the
        Sites or a mobile application. While Spur follows generally accepted
        industry standards to protect the information submitted to Us, no method
        of transmission over the Internet, or method of electronic storage, is
        completely secure. Therefore, while Spur strives to use commercially
        acceptable means to protect Your personal information, Spur cannot
        guarantee its absolute security. For information specific to credit card
        processing and data security please review these specific sections under
        this Privacy Policy.
      </p>
      <h4>Credit Card Processing and Data Security</h4>
      <p>
        Spur does not receive or distribute funds directly from or to You when
        You utilize the Sites or the Services. Spur utilizes a third party
        billing and payment processing gateway, provided by Stripe, Inc., who
        provides the infrastructure and security necessary to provide secure
        transmission of Your credit card transaction data. Stripe, Inc.’s terms
        of service are available at{' '}
        <a href="https://stripe.com/us/legal"> https://stripe.com/us/legal</a>{' '}
        and its privacy policy is available at{' '}
        <a href="https://stripe.com/us/privacy">
          {' '}
          https://stripe.com/us/privacy
        </a>
        , which are incorporated by reference herein. Spur can only accept
        credit cards for processing through Our secured payment processing
        gateway. Although We do not control the security environment for them
        and cannot make any guarantees regarding the secure processing of Your
        credit card transaction data, We want to inform You that Our credit card
        processor is compliant with the Payment Card Industry Data Security
        Standard (“PCI DSS”) as a Level 1 service provider. We demand that Our
        credit card processors are compliant with PCI DSS. PCI DSS is the
        bankcard industry’s stringent security standard. Examples of Our credit
        card processor’s security measures include: physical, electronic, and
        procedural safeguards; sophisticated security monitoring tools;
        documented security policies; use of strong encryption for transmissions
        of order information to and from Our customers; restricting access to
        personal information; and periodic security audits by third party
        security experts.
      </p>
      <h4>Social Media</h4>
      <p>
        Any information, communications, or material of any type or nature that
        You submit to the Sites or through Spur’s Services (including, but not
        limited to any Spur Sites contained on a social media platform or Web
        site such as Facebook, Instagram or Twitter) by e-mail, posting,
        messaging, uploading, downloading, or otherwise (collectively, a
        “Submission”), is done at Your own risk and without any expectation of
        privacy. Spur cannot control the actions of other users of any social
        media platform or Web site and Spur is therefore not responsible for any
        content or Submissions contained on such sites and platforms. By
        visiting any Spur Site that is contained on a social media platform or
        Web site, You are representing and warranting to Spur that You have
        reviewed the applicable Privacy Policy and terms of use of such platform
        or Web site and that You will abide by all such provisions contained
        therein. Additionally, in the event that Spur offers a message board or
        any other interactive or social-type feature on the Sites, please be
        aware that these areas may allow You to publicly post, and share with
        other users, certain messages, content, or other information (e.g.,
        stories, pictures, tips, etc.). Although Spur may take certain
        precautions to protect those who use these areas of the Sites, Spur
        encourages You to be wary of providing any of Your personal information
        in such public forums. The information You submit can be collected and
        used by people You don’t know. Spur does not guarantee the privacy and
        safety of these areas and is therefore not responsible for any
        information You choose to submit. Your use of these features is fully at
        Your own risk.
      </p>
      <h4>International Users</h4>
      <p>
        If You are visiting from the European Union or other regions with laws
        governing data collection and use that may differ from U.S. law, please
        note that You are transferring information about You, including personal
        information, to a country and jurisdiction that does not have the same
        data protection laws as the European Union, and You consent to the
        transfer of information about You, including Your personal information,
        to the U.S.; and the use and disclosure of information about You,
        including Your personal information, as described in this Privacy
        Policy.
      </p>
      <h4>Monitoring and Enforcement</h4>
      <p>
        Spur has implemented various measures to monitor compliance with and
        enforce the elements in this Privacy Policy. If You have a privacy
        related inquiry, complaint or dispute, please contact Us at the postal
        or e-mail listed in the Contact and Electronic Communication section of
        this Privacy Policy.
      </p>
    </LegalDocument>
  );
}

export default PolicyEn;
